import { Auth0Client } from '@auth0/auth0-spa-js';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID } from '../config/vars';

let auth0Client;

export const auth0Init = async () => {
  auth0Client = new Auth0Client({
    domain: AUTH0_DOMAIN,
    clientId: AUTH0_CLIENT_ID,
    authorizationParams: {
      audience: 'https://api-core.auravision.ai'
    }
  });
  await auth0Client.checkSession();
  return auth0Client;
};

export const checkAuth = async () => {
    return auth0Client? await auth0Client.isAuthenticated() : false;
}

export const getAuth0Client = () => auth0Client;
